import type { IconDef } from '../types';

export const youtube: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M20.775 8.05455C20.55 6.63636 19.875 5.65455 18.3 5.43636C15.825 5 12 5 12 5C12 5 8.175 5 5.7 5.43636C4.125 5.65455 3.3375 6.63636 3.225 8.05455C3 9.47273 3 11.5455 3 11.5455C3 11.5455 3 13.6182 3.225 15.0364C3.45 16.4545 4.125 17.4364 5.7 17.6545C8.175 18.0909 12 18.0909 12 18.0909C12 18.0909 15.825 18.0909 18.3 17.6545C19.875 17.3273 20.55 16.4545 20.775 15.0364C21 13.6182 21 11.5455 21 11.5455C21 11.5455 21 9.47273 20.775 8.05455ZM9.75 14.8182V8.27273L15.375 11.5455L9.75 14.8182Z',
    },
  ],
};
